export default __webpack_public_path__ + "static/media/club.21f93c61.webp";